import { Component } from "@angular/core";
import { ChannelDefinitionRepo } from "../../repos/channel-definition.repo";

@Component({
  templateUrl: "./list.component.html",
})
export class ChannelDefinitionListComponent {
  constructor(public repo: ChannelDefinitionRepo) {}
}
